export default "__VITE_ASSET__RrNcDWnL__"